import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { StyledContentDivider } from './ContentDivider.styles';

class ContentDivider extends Component {
  static propTypes = {
    /** adds divide line before content */
    before: PropTypes.bool,
    /** adds divide line after content */
    after: PropTypes.bool,
    /** Components to live inside divider - between the divide lines */
    children: PropTypes.node,
    /** Theme prop */
    theme: PropTypes.oneOf(['default', 'hr'])
  };

  static defaultProps = {
    before: false,
    after: false,
    children: null,
    theme: 'default'
  };

  render() {
    const { before, after, children, theme } = this.props;

    let position;

    if (before && !after) {
      position = '&:before';
    } else if (!before && after) {
      position = '&:after';
    } else if (before && after) {
      position = '&:before, &:after';
    }

    return (
      <StyledContentDivider theme={theme} position={position}>
        {children}
      </StyledContentDivider>
    );
  }
}

export default ContentDivider;
